import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

const Flag = ({ className, lang }) => {
  lang = lang.toLowerCase()
  let url = ''
  if (lang.includes('https://')) {
    url = new URL(lang)
    lang = url.host.replaceAll('.', '')
  }
  const data = useStaticQuery(graphql`
    {
      wwwapexauctionscouk: file(relativePath: { eq: "flags/uk.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      unitedkingdom: file(relativePath: { eq: "flags/uk.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionscom: file(relativePath: { eq: "flags/us.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      unitedstates: file(relativePath: { eq: "flags/us.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionsit: file(relativePath: { eq: "flags/it.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      italy: file(relativePath: { eq: "flags/it.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionsca: file(relativePath: { eq: "flags/ca.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      canada: file(relativePath: { eq: "flags/ca.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionsfr: file(relativePath: { eq: "flags/fr.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      france: file(relativePath: { eq: "flags/fr.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionsde: file(relativePath: { eq: "flags/de.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      germany: file(relativePath: { eq: "flags/de.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionscoza: file(relativePath: { eq: "flags/za.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexassetflowcoza: file(relativePath: { eq: "flags/za.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      southafrica: file(relativePath: { eq: "flags/za.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapex86com: file(relativePath: { eq: "flags/cn.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      china: file(relativePath: { eq: "flags/cn.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionsin: file(relativePath: { eq: "flags/in.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      india: file(relativePath: { eq: "flags/in.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionses: file(relativePath: { eq: "flags/es.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      spain: file(relativePath: { eq: "flags/es.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionspl: file(relativePath: { eq: "flags/pl.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      poland: file(relativePath: { eq: "flags/pl.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      wwwapexauctionsro: file(relativePath: { eq: "flags/ro.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      romania: file(relativePath: { eq: "flags/ro.png" }) {
        childImageSharp {
          gatsbyImageData(height: 25, placeholder: NONE, layout: FIXED)
        }
      }
      ae: file(relativePath: { eq: "flags/ae.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      ar: file(relativePath: { eq: "flags/ar.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      at: file(relativePath: { eq: "flags/at.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      au: file(relativePath: { eq: "flags/au.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      be: file(relativePath: { eq: "flags/be.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      br: file(relativePath: { eq: "flags/br.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      ca: file(relativePath: { eq: "flags/ca.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      ch: file(relativePath: { eq: "flags/ch.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      cl: file(relativePath: { eq: "flags/cl.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      cn: file(relativePath: { eq: "flags/cn.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      cz: file(relativePath: { eq: "flags/cz.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      de: file(relativePath: { eq: "flags/de.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      dk: file(relativePath: { eq: "flags/dk.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      eg: file(relativePath: { eq: "flags/eg.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      es: file(relativePath: { eq: "flags/es.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      fi: file(relativePath: { eq: "flags/fi.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      fr: file(relativePath: { eq: "flags/fr.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      gn: file(relativePath: { eq: "flags/gn.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      hr: file(relativePath: { eq: "flags/hr.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      hu: file(relativePath: { eq: "flags/hu.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      id: file(relativePath: { eq: "flags/id.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      ie: file(relativePath: { eq: "flags/ie.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      in: file(relativePath: { eq: "flags/in.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      is: file(relativePath: { eq: "flags/is.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      it: file(relativePath: { eq: "flags/it.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      kr: file(relativePath: { eq: "flags/kr.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      mt: file(relativePath: { eq: "flags/mt.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      mx: file(relativePath: { eq: "flags/mx.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      my: file(relativePath: { eq: "flags/my.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      nl: file(relativePath: { eq: "flags/nl.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      no: file(relativePath: { eq: "flags/no.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      pl: file(relativePath: { eq: "flags/pl.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      pr: file(relativePath: { eq: "flags/pr.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      pt: file(relativePath: { eq: "flags/pt.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      ro: file(relativePath: { eq: "flags/ro.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      sa: file(relativePath: { eq: "flags/sa.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      se: file(relativePath: { eq: "flags/se.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      sg: file(relativePath: { eq: "flags/sg.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      si: file(relativePath: { eq: "flags/si.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      sk: file(relativePath: { eq: "flags/sk.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      tr: file(relativePath: { eq: "flags/tr.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      ua: file(relativePath: { eq: "flags/ua.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      uk: file(relativePath: { eq: "flags/uk.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      us: file(relativePath: { eq: "flags/us.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
      za: file(relativePath: { eq: "flags/za.png" }) {
        childImageSharp {
          gatsbyImageData(height: 16, placeholder: NONE, layout: FIXED)
        }
      }
    }
  `)
  if (!lang) return null
  if (data[lang]?.childImageSharp.gatsbyImageData) {
    var languageImage = data[lang].childImageSharp.gatsbyImageData
  }
  if (!languageImage) return null
  return <GatsbyImage className={className} role='presentation' image={languageImage} alt={`${url} site`} />
}

export default Flag
